export const LINE_ITEM_TYPES = {
  USER: 'User',
  ACCOUNT: 'Account',
  ROLE: 'Role',
  ENTITLEMENT: 'Entitlement',
  CHILD_ENTITLEMENT: 'Child Entitlement',
};

export const ROLE_TYPES = { APPLICATION_ROLE: 'APPLICATION ROLE' };
